import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import TeacherGradebookWrapper from "./routes/TeacherGradebookWrapper";
export default store => ({
  path: "courses",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-gradebook" */ "./components"),
        import(
          /* webpackChunkName: "admin-gradebook" */ "Gradebook/modules/GradebookModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "gradebook",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [TeacherGradebookWrapper(store)],
});
